import { Link } from 'react-router-dom';
import { useTranslation } from '@/contexts/LanguageContext';
import { Home, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SEO from '@/components/SEO';

export default function NotFoundPage() {
  const { t } = useTranslation('notFound');

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="not-found-page">
      <SEO title="Page introuvable" noindex />
      <div className="text-center max-w-md">
        <p className="text-8xl font-black text-[#1F3F72]/10 dark:text-white/10 leading-none mb-4">404</p>
        <h1 className="text-2xl font-bold text-neutral-900 dark:text-white mb-2">{t('title')}</h1>
        <p className="text-neutral-500 dark:text-neutral-400 mb-8">{t('subtitle')}</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button asChild className="bg-[#1F3F72] text-white">
            <Link to="/">
              <Home className="w-4 h-4 mr-2" /> {t('backHome')}
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/annonces">
              <Search className="w-4 h-4 mr-2" /> {t('browseListings')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
